export * from './config';
export * from './persistence';
export * from './database';

import { enableOfflinePersistence } from './persistence';

// Initialize offline persistence
enableOfflinePersistence().catch(console.error);